import { useState, useEffect } from 'react';

function useIpAddress() {
  const [ipAddress, setIpAddress] = useState(null);

  useEffect(() => {
    async function fetchIpAddress() {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      setIpAddress(data.ip);
    }
    fetchIpAddress();
  }, []);

  return ipAddress;
}
export default useIpAddress